import type {IconBase} from '../types/global';
import {getColors} from '../utils/styles';

const colors = getColors();

export const AddPhotosLineIcon = ({
  color = colors.charcoal,
  className = '',
  ratio = 1,
}: IconBase) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  const colorValue = colors[color] || (color as string);

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      role="img"
      aria-label="Add Photo"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Add Photo</title>
      <path
        d="M28.0003 20V24H32.0003V26.6667H28.0003V30.6667H25.3337V26.6667H21.3337V24H25.3337V20H28.0003ZM28.011 4C28.7417 4 29.3337 4.59333 29.3337 5.324V17.3333H26.667V6.66667H5.33366V25.332L18.667 12L22.667 16V19.772L18.667 15.772L9.10299 25.3333H18.667V28H3.98966C3.63874 27.9996 3.30232 27.86 3.05431 27.6117C2.8063 27.3635 2.66699 27.0269 2.66699 26.676V5.324C2.66943 4.97384 2.80953 4.63869 3.05701 4.39096C3.30449 4.14322 3.6395 4.00279 3.98966 4H28.011ZM10.667 9.33333C11.3742 9.33333 12.0525 9.61428 12.5526 10.1144C13.0527 10.6145 13.3337 11.2928 13.3337 12C13.3337 12.7072 13.0527 13.3855 12.5526 13.8856C12.0525 14.3857 11.3742 14.6667 10.667 14.6667C9.95975 14.6667 9.28147 14.3857 8.78137 13.8856C8.28128 13.3855 8.00033 12.7072 8.00033 12C8.00033 11.2928 8.28128 10.6145 8.78137 10.1144C9.28147 9.61428 9.95975 9.33333 10.667 9.33333Z"
        fill={colorValue}
      />
    </svg>
  );
};
